import { defineComponent as n, openBlock as r, createBlock as l, resolveDynamicComponent as s, normalizeClass as a, unref as o, withCtx as m, renderSlot as p } from "vue";
import t from "../../node_modules/.pnpm/@patternfly_react-styles@5.3.1/node_modules/@patternfly/react-styles/css/layouts/Level/level.js";
const d = /* @__PURE__ */ n({
  name: "PfLevel",
  __name: "Level",
  props: {
    component: { default: "div" },
    gutter: { type: Boolean }
  },
  setup(f) {
    return (e, u) => (r(), l(s(e.component), {
      class: a([o(t).level, { [o(t).modifiers.gutter]: e.gutter }])
    }, {
      default: m(() => [
        p(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  d as default
};
